var BlogAddon = (function () {

    function initializeCategoriesMenuButton() {
        $(".blog-categories-menu-button").on('click', function () {
            var blogCategoriesMenuButtonTextElement = $(this).find(".btn-text");
            var currentText = blogCategoriesMenuButtonTextElement.text();
            var categoriesText = currentText.substring(0, currentText.length - 1);
            var blogCategoriesMenuContainer = $(".blog-categories-menu-container");
            if (blogCategoriesMenuContainer.height() === 0) {
                blogCategoriesMenuContainer.addClass("show-menu");
                blogCategoriesMenuContainer.removeClass("hide-menu");
                blogCategoriesMenuButtonTextElement.text(categoriesText + "-");
                return;
            }

            blogCategoriesMenuContainer.addClass("hide-menu");
            blogCategoriesMenuContainer.removeClass("show-menu");
            blogCategoriesMenuButtonTextElement.text(categoriesText + "+");
        });
    }

    function initialize() {
        initializeCategoriesMenuButton();
    }

    return {
        initialize: initialize
    };

})();

$(function () {
    BlogAddon.initialize();
});